/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
// import {BrowserRouter as Router, Route, Link,} from 'react-router-dom';
import {HashRouter as Router, Route, Link} from 'react-router-dom';

import App from './Home';
import Home1 from './Home1';
import ProductsAndServices from './ProductsAndServices/index.jsx';
import TalentStrategy from './TalentStrategy';
import News2 from './News2';
import News3 from './News3';
import News from './News';
import ContactUs from './ContactUs';
import AboutUs from './AboutUs';
import Demo from './components/GisDemo';

//管理页
function AppRouter() {
    return (
        <Router>
            {/*组件*/}
            <Route path="/demo" component={Demo}/>
            {/*首页*/}
            {/*<Route path="/" component={App}/>*/}
            <Route path="/" exact component={App}/>

            {/*示例*/}
            <Route path="/home1" component={Home1}/>
            {/*核心业务*/}
            <Route path="/productsAndServices" component={ProductsAndServices}/>
            {/*人才战略*/}
            <Route path="/talentStrategy" component={TalentStrategy}/>
            {/*新闻资讯-首页*/}
            <Route path="/news" component={News}/>
            {/*新闻资讯-列表页*/}
            <Route path="/news2" component={News2}/>
            {/*新闻资讯-详情页*/}
            <Route path="/news3" component={News3}/>
            {/*联系我们*/}
            <Route path="/contactUs" component={ContactUs}/>
            {/*关于我们*/}
            <Route path="/aboutUs" component={AboutUs}/>

        </Router>
    );
}

ReactDOM.render(<AppRouter/>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
